import React from 'react';
import { useIntl } from 'react-intl';

import styled, { ThemeContext } from 'styled-components';
import { JRCInputColorRaw } from '../../Form/Input/JRCInputColor/JRCInputColorRaw';

export const CSSJRCColorPicker = styled.div`
    min-height: 40px;
    width: 100%;
    left: 0px;
    top: 0px;
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.color.grey2};
`;

export const EditorColorPicker = ({
    initialValue = '#4D9DE0',
    onChange,
}: {
    colors?: string[];
    initialValue?: string;
    onChange: (color: string) => void;
}) => {
    const themeContext = React.useContext(ThemeContext);
    const intl = useIntl();

    const palettes = [
        {
            name: intl.formatMessage({ id: 'GLOBAL_Platform_Color' }),
            colors: [
                themeContext.color.primary,
                themeContext.color.secondary,
                themeContext.color.headerColor,
                themeContext.color.lavender,
                themeContext.color.orange,
                themeContext.color.green,
                themeContext.color.navy,
                themeContext.color.overseas,
            ],
        },
    ];

    return (
        <>
            <JRCInputColorRaw
                palettes={palettes}
                initialValue={initialValue}
                name="color"
                onChange={(color) => {
                    if (initialValue !== color) {
                        onChange(color);
                    }
                }}
            />
        </>
    );
};
